__webpack_require__.p = "/kidlab-reg/";